export default function Logo() {
    return (
        <img src="../img/logo_transparent_background_new.png" className="img-fluid" alt="Virkverket" width="500"></img>
    );
}
   
